export const CDS_DB_NAME = "clinical-decision-support";
export const GENERAL_RECENCY_WINDOW_MS = 1000 * 60 * 60 * 24; // 1 day
